const initPendingPotentialsModal = () => {
  const wrapper = document.querySelector('.users-pending-potentials-modal');
  if (!wrapper) return;

  const { formSelector } = wrapper.dataset;
  const form = document.querySelector(formSelector);
  if (!form) return;

  const modal = document.querySelector('.users-pending-potentials-modal__modal');
  if (!modal) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    document.body.classList.add('disable-scroll');
    modal.classList.remove('modal--hide');
  });

  modal.querySelectorAll('[data-update-pending-potentials]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const val = btn.dataset.updatePendingPotentials === 'true' ? '1' : '0';
      form.querySelector('input[name=update_pending_potentials]').value = val;
      form.submit();
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPendingPotentialsModal);
} else {
  initPendingPotentialsModal();
}
document.addEventListener('turbo:load', initPendingPotentialsModal);
